import { useAuth } from '@shared/common/providers/AuthProvider';
import { DEFAULT_TARGET_CHAIN, tokensInfo } from '@shared/constants';
import { TokenName } from '@shared/constants';
import { parseWei } from '@shared/helpers/web3/formatters';
import { useTokenBalance } from '@shared/helpers/web3/hooks/useTokenBalance';

type Props = {
  tokenName: TokenName;
};

export const useTokenBalanceByName = ({ tokenName }: Props) => {
  const { userEvmWallet } = useAuth();
  const { contractsAddresses } = tokensInfo[tokenName];

  const response = useTokenBalance({
    address: userEvmWallet?.attributes.address,
    token: contractsAddresses.token,
    chainId: DEFAULT_TARGET_CHAIN.id,
  });

  return response?.data
    ? {
        ...response,
        data: parseWei({ wei: response?.data?.value, tokenName }),
      }
    : response;
};
